import type { ProjectPageLayoutProps } from "app/areas/projects/components/ProjectPaperLayout";
import { ProjectPaperLayout } from "app/areas/projects/components/ProjectPaperLayout";
import * as React from "react";
export const ProjectContextPaperLayout: React.FC<ProjectPageLayoutProps> = ({ children, ...rest }) => <ProjectPaperLayout {...rest}>{children}</ProjectPaperLayout>;
ProjectContextPaperLayout.displayName = "ProjectContextPaperLayout"
